import { Box, Grid, Icon, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useRef } from 'react';
import C from '@shared/constants/general';
import { markdownMini } from '@/lib/utils/DataFormat';
import { getDurationShort } from '@/lib/utils/StringFormat';
import ParticipantPopup from '@/js/shared/components/ui/ParticipantPopup';
import UserAvatar from '@/components/ui/userAvatar';

const useStyles = (theme) => ({
  descriptionText: {
    whiteSpace: 'pre-line !important',
  },
  currentText: {
    width: '30px !important',
    backgroundColor: '#f33 !important',
    color: '#fff !important',
    padding: '2px 4px 0px 4px !important',
    fontSize: '10px !important',
    borderRadius: '3px !important',
    marginBottom: '5px !important',
    marginTop: '5px !important',
  },
  linkButton: {
    fontSize: '0.7rem !important',
    marginRight: '5px !important',
    marginBottom: '5px !important',
    // marginTop: -3,
    // padding: '2px 4px 2px 0',
  },
  linkButtonIcon: {
    marginRight: '2px !important',
    '& > .MuiIcon-root': {
      fontSize: '14px !important',
    },
  },
  linkListHolder: {
    fontSize: '0.75rem !important',
  },
  individualText: {
    padding: '10px !important',
  },
  bookmarkIcon: {
    verticalAlign: 'middle !important',
  },
  titleHolder: {
    position: 'relative !important',
  },
  titleText: {
    fontSize: '1.1rem !important',
  },
  profileName: {
    color: `${theme.palette.text.primary} !important`,
    fontSize: '0.8rem !important',
    textDecoration: 'underline !important',
  },
  profileInfo: {
    fontSize: '0.8rem !important',
    // color: 'rgba(255, 255, 255, 0.7)',
  },
});
const infoList = (infos) => {
  const filtered = infos.filter((info) => !!info);
  return filtered.join(', ');
};

const EventDescription = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const userModalRef = useRef();
  const isLive = props.current;

  const displayedVisitors = props.event.visitors.filter(
    (v) =>
      v.eventVisitors.type === C.EVENT_VISITOR_TYPE.SPEAKER ||
      v.eventVisitors.type === C.EVENT_VISITOR_TYPE.MODERATOR
  );
  const userPopup = (visitor) => (e) => {
    e.preventDefault();
    userModalRef.current.setState({ open: true, user: visitor });
  };

  return (
    <Box>
      <ParticipantPopup ref={userModalRef} />
      <Grid container spacing={0}>
        <Grid item size={{ xs: 12, md: 8 }} sx={classes.titleHolder}>
          {isLive && <Box sx={classes.currentText}>LIVE</Box>}
          <Typography variant="h5" sx={classes.titleText}>
            {props.event.title}
          </Typography>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box align="right">
            {props.timeReactions && props.timeReactions.length > 0 && (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                flexGrow={1}
                align="right"
              >
                {props.timeReactions.map((reaction) => (
                  <Link
                    color="inherit"
                    underline="always"
                    component="button"
                    onClick={() => props.reactionCallback(reaction)}
                    variant="body2"
                    key={reaction.id}
                  >
                    <Icon sx={classes.bookmarkIcon} color="primary">
                      bookmark
                    </Icon>
                    {getDurationShort(reaction.eventTimeStart)}
                  </Link>
                ))}
                <Box px={1}>
                  <Typography variant="subtitle2">Favorites</Typography>
                </Box>
              </Box>
            )}
            {props.nextEventId && (
              <Link href={`/live/session/${props.nextEventId}`}>
                Next&nbsp;&gt;
              </Link>
            )}
          </Box>
        </Grid>
      </Grid>
      <Box>
        <Box>
          <Typography
            variant="body2"
            gutterBottom
            dangerouslySetInnerHTML={markdownMini(props.event.description)}
            sx={classes.descriptionText}
          />
        </Box>
        {displayedVisitors.length > 0 && (
          <Grid container>
            {displayedVisitors.map((v) => (
              <Grid item size={{ xs: 12, md: 6 }} key={v.id}>
                <Box display="flex" flexDirection="column">
                  <Box display="flex" py={1}>
                    <UserAvatar size="medium" user={v} />
                    <Box pl={1}>
                      <Typography variant="body2">
                        <Link
                          href="#"
                          sx={classes.profileName}
                          onClick={userPopup(v)}
                        >
                          {v.full_name}
                        </Link>
                      </Typography>
                      <Typography variant="body2" sx={classes.profileInfo}>
                        <em>{infoList([v.title, v.company])}</em>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default EventDescription;
